import couponApi from './coupon-api';

export default {

	getCouponDetails(couponCode) {
		return couponApi.getCouponDetails(couponCode);
	},

	getMaintenanceCouponDetails(couponCode, currentSub) {
		return this.getCouponDetails(couponCode)
			.then((response) => {
				if (response.type !== 'PrepaidMaintenance') {
					return Promise.reject('INVALID_COUPON_TYPE');
				}
				if (response.tierName !== currentSub?.plan?.tierName) {
					return Promise.reject('INVALID_COUPON_TIER');
				}

				return Promise.resolve(response);
			});
	}

};



// WEBPACK FOOTER //
// ./src/modules/coupon-service.js